// src/components/Toast.js
import React from 'react';
export default function Toast({ message, type = 'default' }) {
  if (!message) return null;
  const cls = type === 'error' ? 'toast toast-error' : type === 'success' ? 'toast toast-success' : 'toast';
  return <div className={cls}>{message}</div>;
}
